import { Box, Center } from '@chakra-ui/react';
import { GraphQLReqStatus } from '@gamma/ui/progress';
import { Row } from 'react-table';
import { useGetAlertMetadata, useGetDetections } from '../../queries';

import { DetectionDetails, SantizedDetection } from '../../pages';

interface ExpandedTableRowProps {
  rowData: Row<SantizedDetection>;
}

export const ExpandedTableRow = ({ rowData }: ExpandedTableRowProps) => {
  const { detection_id, tenant_info } = rowData.original;

  const getDetectionVariables = {
    detection_ids: [
      {
        detection_id,
        tenant: tenant_info?.tenant_id,
      },
    ],
  };

  const {
    loading: detectionLoading,
    data: detectionData,
    error: detectionError,
  } = useGetDetections({
    skip: !detection_id || !tenant_info?.tenant_id,
    variables: getDetectionVariables,
  });

  const {
    loading: metadataLoading,
    data: metadataData,
    error: metadataError,
  } = useGetAlertMetadata({
    skip:
      !tenant_info?.tenant_id ||
      !detectionData?.getDetections?.detections[0]?.alert_info?.content_id,
    variables: {
      items: [
        {
          content_id:
            detectionData?.getDetections?.detections[0]?.alert_info?.content_id,
          tenant: tenant_info?.tenant_id,
        },
      ],
    },
  });

  const isLoading = detectionLoading || metadataLoading;

  return (
    <Box w="100%">
      {isLoading || detectionError || metadataError ? (
        <Center>
          <GraphQLReqStatus
            loading={isLoading}
            error={detectionError || metadataError}
          />
        </Center>
      ) : (
        <DetectionDetails
          detailsProps={{
            detectionData,
            detectionError,
            detectionLoading,
            metadataData,
            metadataError,
            metadataLoading,
          }}
        />
      )}
    </Box>
  );
};
